"use strict";
/*
 * @license
 * Copyright (c) 2019 Cristian Abrante. All rights reserved.
 * Licensed under the MIT License. See LICENSE in the project root for license information.
 */

Object.defineProperty(exports, "__esModule", {
  value: true
});

var NumericGenerator_1 = require("./NumericGenerator");

exports.NumericGenerator = NumericGenerator_1.default;